export default "__VITE_ASSET__ZuZhNHMS__"